import {getTeamMembers} from '@/api/team';
import {useQuery} from '@tanstack/react-query';

export function useTeamMembers() {
    return useQuery({
        queryKey: ['teamMembers'],
        queryFn: getTeamMembers
    });
}
